(function ($) {
    $(document).on('click', '.followme-faq-row-box-title', function () {
        var parent = $(this).parent();

        if(parent.hasClass("opened")){
            parent.find(".followme-faq-row-box-content").slideUp();
            parent.removeClass("opened");
        } else {
            parent.find(".followme-faq-row-box-content").slideDown();
            parent.addClass("opened");
        }
    });
})(jQuery);